module.exports = __webpack_public_path__ + "img/successicon.6229fdba.png";